export const getInitials = (name) => {
  if (!name) return 'U';
  return name
    .split(' ')
    .map(word => word.charAt(0))
    .join('')
    .substring(0, 2)
    .toUpperCase();
};

const PREFS_BASE = (process.env.REACT_APP_PREFS_BASE_URL ?? '').trim(); // '' means disabled/skip network
const PREFS_PATH = (process.env.REACT_APP_PREFS_PATH ?? '/api/preferences').trim();

export async function loadUserPreferences(email, setAvailableSources, defaultProjects) {
  // Try localStorage first
  try {
    const cached = localStorage.getItem(`prefs:${email}:sources`);
    if (cached) {
      setAvailableSources(JSON.parse(cached));
    } else {
      setAvailableSources(defaultProjects);
    }
  } catch {
    setAvailableSources(defaultProjects);
  }

  // If no remote configured, stop here (prevents connection refused)
  if (!PREFS_BASE) return;

  // Otherwise attempt network fetch, but do not throw on failure
  try {
    const base = PREFS_BASE.replace(/\/$/, '');
    const url = `${base}${PREFS_PATH}/${encodeURIComponent(email)}/sources`;
    const res = await fetch(url, { method: 'GET' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    if (Array.isArray(data) && data.length) {
      setAvailableSources(data);
      try {
        localStorage.setItem(`prefs:${email}:sources`, JSON.stringify(data));
      } catch {}
    }
  } catch {
    // Swallow errors to avoid noisy console; keep defaults/localStorage
  }
}
